import { render, staticRenderFns } from "./PaymentButtonGroup.vue?vue&type=template&id=516a1469&scoped=true"
import script from "./PaymentButtonGroup.vue?vue&type=script&lang=js"
export * from "./PaymentButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./PaymentButtonGroup.vue?vue&type=style&index=0&id=516a1469&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516a1469",
  null
  
)

export default component.exports